import { fetchGet, fetchPost, fetchPut } from '~shared/util/fetchUtil'
import { getAuthToken, getRequestAuthOptions } from '~shared/util/authUtil'
import GlobalStore from '../Stores/GlobalStore'
import type { BarcodeItemInfo } from '../Utils/BarcodeReader'
import type { Order } from '../Types/Order'
import type { OrderItem } from '../Types/OrderItem'
import type {
  DepartmentAvailabilityStatusResponse,
  SetDepartmentAvailabilityRequest,
} from '../Types/DepartmentAvailability'

export type OrdersResponse = {
  orders: Order[]
  unconfirmedActiveCount: number
  unconfirmedUpcomingCount: number
  newActiveCount: number
}

export async function getItemBarcodeItemInfo(_barcode: string): Promise<BarcodeItemInfo[]> {
  throw new Error('Not implemented — provided by KDS API integration PR')
}

export async function fetchOrders(
  statusSegment: string,
  signal?: AbortSignal
): Promise<OrdersResponse> {
  const options = signal ? { token: getAuthToken(), signal } : { token: getAuthToken() }

  return fetchGet<OrdersResponse>(
    `${GlobalStore.apiUrl}/orders/department/status/${statusSegment}`,
    options
  )
}

export async function fetchDepartmentAvailability(): Promise<boolean> {
  return fetchGet<boolean>(`${GlobalStore.apiUrl}/orders/department/availability`, {
    token: getAuthToken(),
  })
}

export async function updateDepartmentAvailability(
  available: boolean,
  stepUpToken?: string
): Promise<void> {
  await fetchPost<unknown>(
    `${GlobalStore.apiUrl}/orders/department/availability`,
    available,
    getRequestAuthOptions(stepUpToken)
  )
}

export async function fetchDepartmentAvailabilityStatus(): Promise<DepartmentAvailabilityStatusResponse> {
  return fetchGet<DepartmentAvailabilityStatusResponse>(
    `${GlobalStore.apiUrl}/orders/department/availability/status`,
    { token: getAuthToken() }
  )
}

export async function updateDepartmentAvailabilityStatus(
  request: SetDepartmentAvailabilityRequest,
  stepUpToken?: string
): Promise<void> {
  await fetchPost<unknown>(
    `${GlobalStore.apiUrl}/orders/department/availability/status`,
    request,
    getRequestAuthOptions(stepUpToken)
  )
}

export async function editOrder(
  orderId: string,
  payload: { status: string | null; items?: OrderItem[] }
): Promise<void> {
  await fetchPut<unknown>(`${GlobalStore.apiUrl}/kds/orders/edit/${orderId}`, payload, {
    token: getAuthToken(),
  })
}

export async function cancelOrder(orderId: string, stepUpToken?: string): Promise<void> {
  await fetchPost<void>(
    `${GlobalStore.apiUrl}/orders/${orderId}/cancel`,
    {},
    getRequestAuthOptions(stepUpToken)
  )
}

export async function printOrder(orderId: string): Promise<void> {
  await fetchPost<void>(`${GlobalStore.apiUrl}/orders/department/${orderId}/print`, null, {
    token: getAuthToken(),
  })
}
